export default "__VITE_ASSET__BP0O6$PU__"